import React from 'react'
import Button from '../ui/Button.tsx'
import useFlickerEffect from '../../hooks/useFlickerEffect.ts';

const Getademo = () => {
    const activeClass = useFlickerEffect();
    return (
        <>
            <div className={`relative
                 after:absolute 
                 after:top-[-115%] 
                 after:left-0
                 after:bg-[url('../src/assets/images/lefteffect.png')]
                 after:bg-no-repeat
                 after:max-w-[400px]
                 after:w-full
                 after:h-[2000px]
                 ${activeClass && 'after:animate-flicker'}
                 after:hidden
                 after:xl:block
            `}>
                <div className='max-w-[931px] w-full mx-auto px-5' >
                    <div className={`py-[12px] flex flex-col justify-center md:py-[19px] md:px-[41px] px-[21px]
                 relative 
                 after:absolute 
                 after:left-0
                 after:h-[54px]
                 after:w-[23px]
                 after:bottom-[-13px]
                 after:bg-[url('../src/assets/icons/arrowlefticon.svg')]
                 before:top-[0px]
                 before:right-0
                 before:absolute
                 before:bg-[url('../src/assets/icons/leftarrow.svg')]
                 before:h-[52px]
                 before:w-[23px]
                 `}>
                        <div className=" pb-8  text-center ">
                            <h4 className='font-gothicproLight md:text-[22px] text-base text-[#C9C9C9] md:pb-2 pb-1 leading-[32.78px] ' >Al final del día, sólo una pregunta importa:</h4>
                            <h2 className='text-white  text-nowrap  text-base md:text-[30px] lg:text-[40px]  xl:text-[50px] font-gothicproMedium leading-[120%]  '>¿PUEDES SER <span className='text-[#2972D7] '>HACKEADO</span>?</h2>
                        </div>
                        <a href="#contactsection" className='flex justify-center '>
                            <Button varient="solid" buttonClass="px-[22px] md:pt-[17px] md:pb-[15px] pl-[30px] pr-[34px] font-bold text-nowrap leading-4">
                                Obtén un demo
                            </Button>
                        </a>
                    </div>
                </div >
            </div >
        </>
    )
}

export default Getademo